module.exports = __webpack_public_path__ + "img/1531617210.23ed87d5.jpg";